// Tilts, stacking, and hover nudges for a row of rec thumbnails laid over a
// hero image. Shared by the collection cards (RecommendationCollectionCard,
// CollectionCover) and the Holiday Market's featured guide cards, so the rows
// look and move alike everywhere.
export const ROW_ROTATIONS = [-12, 8, -6, 10];
export const Z_INDEXES = [14, 13, 12, 11];
/** Hovering a thumbnail nudges it outward: left-up, right-up, left-down, right-down. */
export const ROW_HOVER_TRANSLATIONS = [
  { x: -6, y: -4 },
  { x: 6, y: -2 },
  { x: -4, y: 4 },
  { x: 8, y: 2 },
];
